export enum REFERENTIAL_NAMES {
  ASSET_EVENT_TYPES = "asset-event-types",
  ASSET_TYPE_CATEGORIES = "asset-type-categories",
  CONDITION_RATINGS = "condition-ratings",
  CURRENCIES = "currencies",
  INTERVENTION_TYPES = "intervention-types",
  LANGUAGES = "languages",
  MATERIALS = "materials",
  MODELS = "models",
  MODULES = "modules",
  PROJECT_COST_TYPES = "additional-project-cost-types",
  SCHEDULING_STATES = "scheduling-states",
  USER = "state/users",
}
